import { render } from "./feedback.vue?vue&type=template&id=3384dece&scoped=true"
import script from "./feedback.vue?vue&type=script&lang=js"
export * from "./feedback.vue?vue&type=script&lang=js"

import "./feedback.vue?vue&type=style&index=0&id=3384dece&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3384dece"]])

export default __exports__